import Layout from "../include/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import "datatables.net-bs5";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import ModesPaiementsService from "./ModesPaiementsService";

export default function ModesPaiementsIndex() {
  const activeLink = "MODES PAIEMENTS"

  const token = useSelector((state) => state.auth.token);
  const [modespaiements, setModesPaiements] = useState([]);
  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  const [errors, setErrors] = useState({});

  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [addFormData, setAddFormData] = useState({
    libelleModepaiement: '',
    descriptionModepaiement: '',
  });

  //declaration des variables pour le form d'edition
  const [editFormData, setEditFormData] = useState({
    libelleModepaiement: '',
    descriptionModepaiement: '',
    id: ''
  });

  //get liste niveaux
  const fetchModesPaiements = async () => {
    await ModesPaiementsService.index(token).then((res) => {
      //console.log(res.data.data)
      setModesPaiements(res.data.data.modespaiements);
    })
      .catch((error) => {
        console.log(error);
      });

    //initialize datatable
    $(document).ready(function () {
      $(".data-table").DataTable();
    });
  };

  //####GESTION DES REGLES DE VALIDATIONS ###########///
  const schemaAddData = {
    libelleModepaiement: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionModepaiement: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),
  };

  //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
  const schemaEditData = {

    libelleModepaiement: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionModepaiement: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    id: Joi.number().min(1).empty('').options({
      language: {
        string: { min: "minimum 1" },
      },
    }).label("Id")
  };

  //####END GESTION DES REGLES DE VALIDATIONS ###########///

  //Gérer les changements sur les formulaires d'ajout
  const handleChange = (event) => {
    //console.log(name)
    const { name, value } = event.target;

    setAddFormData({ ...addFormData, [name]: value });

    let errorData = { ...errors };
    const errorMessage = validateProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...addFormData };
    customerData[name] = event.target.value;
    setAddFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaAddData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  //Une fonction pour vider les champs du formulaire
  const clearForm = () => {
    setAddFormData({
      libelleModepaiement: '',
      descriptionModepaiement: '',
    });
  };

  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        ModesPaiementsService.delete(param, token)
          .then((response) => {
            //console.log(response.data)
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              });
              fetchModesPaiements();
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };


  //Gérer les changements sur les formulaires de modification
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({ ...editFormData, [name]: value });
    //console.log(editFormData)
    let errorData = { ...errors };
    const errorMessage = validateEditProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...editFormData };
    customerData[name] = event.target.value;
    setEditFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateEditProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaEditData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };


  //Enregistrer un nouveau niveaux
  const handleStore = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(addFormData,
      schemaAddData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {
      //
      await ModesPaiementsService.store(addFormData, token).then(response => {
        //Fermer le modal
        setIsVisible(false)
        //Vider les champs du formulaire
        clearForm()
        if (response.data.status === 200) {

          //Mettre à jour la liste des niveaux
          fetchModesPaiements()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        setIsVisible(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'ajout de genre
  const addModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleStore}>
      <div className="col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-libelleModepaiement"
          type="text"
          value={addFormData.libelleModepaiement}
          onChange={handleChange}
          required={true}
          name="libelleModepaiement"
        />

        {errors.libelleModepaiement && (
          <div className="alert alert-danger">
            {errors.libelleModepaiement}
          </div>
        )}
      </div>

      <div className="col-md-12 mb-2">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionModepaiement" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionModepaiement"
          onChange={handleChange}
          name="descriptionModepaiement"
          rows="3"
          value={addFormData.descriptionModepaiement}
        ></textarea>

        {errors.descriptionModepaiement && (
          <div className="alert alert-danger">
            {errors.descriptionModepaiement}
          </div>
        )}
      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setIsVisible(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );

  ///Lancer le modal d'edition
  const lauchEdit = async (id) => {
    await ModesPaiementsService.show(id, token).then((response) => {
      const data = response.data.data;
      //console.log(response.data.data)
      setEditFormData({
        libelleModepaiement: data.libelleModepaiement,
        descriptionModepaiement: data.descriptionModepaiement,
        id: id
      })
      setEditModal(true)

    }).catch((error) => {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    });
  }

  //Modification d'un niveau
  const handleUpdate = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(editFormData,
      schemaEditData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {

      //
      await ModesPaiementsService.update(editFormData, token).then(response => {
        //Fermer le modal
        setEditModal(false)
        if (response.data.status === 200) {

          //Mettre à jour la liste des niveaux
          fetchModesPaiements()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        //Fermer le modal
        setEditModal(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'edition de niveau
  const editModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Libelle <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-libelleModepaiement"
            type="text"
            value={editFormData.libelleModepaiement}
            onChange={handleEditChange}
            required={true}
            name="libelleModepaiement"
          />

          {errors.libelleModepaiement && (
            <div className="alert alert-danger">
              {errors.libelleModepaiement}
            </div>
          )}
        </div>
        
      </div>

      <div className="row mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionModepaiement" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionModepaiement"
          onChange={handleEditChange}
          name="descriptionModepaiement"
          rows="3"
          value={editFormData.descriptionModepaiement}
        ></textarea>

        {errors.descriptionModepaiement && (
          <div className="alert alert-danger">
            {errors.descriptionModepaiement}
          </div>
        )}

      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setEditModal(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  useEffect(() => {
    fetchModesPaiements();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card mb-3 mt-3">
          <h5 className="card-header">
            Liste des modes de paiements &nbsp;&nbsp;
            <Button className="rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter un mode de paiement</Button>
          </h5>

          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="bg-primary">
                <tr style={{ color: "white" }}>
                  <th className="cell text-white">#</th>
                  <th className="cell text-white">Libelle</th>
                  <th className="cell text-white">Description</th>
                  <th className="cell text-white">Date modifcation</th>
                  <th className="cell text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {modespaiements.length > 0 &&
                  modespaiements.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">{index + 1}</td>
                      <td className="cell">{item.libelleModepaiement}</td>
                      <td className="cell">
                        <span className="truncate">{item.descriptionModepaiement}</span>
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <Button onClick={() => lauchEdit(item.id)}
                          className="btn btn-sm" severity="warning" style={{ color: "white" }}
                          title="Modifier"
                        >
                          <i className="fas fa-edit"></i>
                        </Button> &nbsp; &nbsp;
                        <Button
                          className="btn btn-sm" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }}
                          onClick={() => onDelete(item.id)}
                          title="Supprimer"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
      </div>

      {/* Modal Ajout des modespaiements*/}
      <CustomAddModal
        modalTitle="Enregistrement mode paiement"
        modalContent={addModalContent}
        visible={isVisible}
        close={() => setIsVisible(false)}
      />

      {/**End Modal Ajout des modespaiements*/}

      {/* Modal Edition des modespaiements*/}
      <CustomEditModal
        modalTitle="Modification mode paiement"
        modalContent={editModalContent}
        visible={editModal}
        close={() => setEditModal(false)}
      />

      {/**End Modal Edition des modespaiements*/}
    </Layout>
  );
}
